export class DisconnectOpenBanking {
  static readonly type = '[Rent] Disconnect open banking';

  constructor() {
  }
}

